import * as utils from '@ivy/fts/utils'
const LS = window.localStorage
/**
 * 存储localStorage
 */
export function setStore(name, content) {
  if (!name) return
  LS.setItem(
    name,
    typeof content !== 'string' ? JSON.stringify(content) : content
  )
}

/**
 * 获取localStorage
 */
export function getStore(name) {
  if (!name) return
  return LS.getItem(name)
}

/**
 * 删除localStorage
 */
export function removeStore(name) {
  if (!name) return
  LS.removeItem(name)
}

/**
 * 取出字符串的空格以及通配符
 * @param {*} str
 */
export function palindrome(str) {
  let arr = str.split('')
  arr = arr.filter(val => {
    return (
      val !== ' ' &&
      val !== ',' &&
      val !== '.' &&
      val !== '?' &&
      val !== ':' &&
      val !== ';' &&
      val !== '`' &&
      val !== "'" &&
      val !== '_' &&
      val !== '/' &&
      val !== '-' &&
      val !== '\\' &&
      val !== '' &&
      val !== '(' &&
      val !== ')'
    )
  })
  return arr.join('')
}

// 预先加载图片
export const loadImage = (url = '') => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.src = url
    img.onload = () => resolve(img)
    img.onerror = reject
  })
}

export async function setDomStyle(dom, styles) {
  if (!dom) return
  for (let k in styles) {
    dom.style[k] = styles[k]
  }
}
export function pxToVw(px) {
  if (isNaN(px)) return 0
  const base = 750
  return `${(px / 750) * 100}vw`
}

class AppGlobal {
  isAndroid: boolean

  init() {
    const win: any = window
    const isAndroid = (this.isAndroid = win.ivynative)
    const functionNames = [
      'nativeLogin',
      'nativeIsLogin',
      'nativeGetInfo',
      'nativeShare',
      'nativePay',
    ]
    if (this.isAndroid) {
      const buildIvynativeAsync = fn => {
        return (...a) => {
          return new Promise(resolve => {
            // 安卓只能格式化字符串
            if (isAndroid && a && a.length) {
              a = a.map(v => (typeof v !== 'object' && v) || JSON.stringify(v))
            }
            resolve(win.ivynative[fn] && win.ivynative[fn](...a))
          })
        }
      }
      for (let fn of functionNames) {
        this[fn] = buildIvynativeAsync(fn)
      }
      return
    }
    const setupWebViewJavascriptBridge = callback => {
      if (win.WebViewJavascriptBridge) {
        return callback(win.WebViewJavascriptBridge)
      }
      if (win.WVJBCallbacks) {
        return win.WVJBCallbacks.push(callback)
      }
      win.WVJBCallbacks = [callback]
      const WVJBIframe = document.createElement('iframe')
      WVJBIframe.style.display = 'none'
      WVJBIframe.src = 'https://__bridge_loaded__'
      document.documentElement.appendChild(WVJBIframe)
      setTimeout(() => {
        document.documentElement.removeChild(WVJBIframe)
      }, 0)
    }
    setupWebViewJavascriptBridge(bridge => {
      const buildBridgeAsync = fn => {
        return option => {
          return new Promise(resolve => {
            bridge.callHandler(fn, option || {}, (...a) => {
              resolve(...a)
            })
          })
        }
      }
      for (let fn of functionNames) {
        this[fn] = buildBridgeAsync(fn)
      }
    })
    this._setupWebViewJavascriptBridge = setupWebViewJavascriptBridge
  }

  nativeLogin: any = () => {}
  nativeIsLogin: any = () => {}
  nativeGetInfo: any = () => {}
  nativeShare: any = () => {}
  nativePay: any = () => {}
  onNativeLogin: any = (cb = data => data) => {
    this._buildListener('onNativeLogin', cb)
  }
  onNativePaySuccess: any = (cb = data => data) => {
    this._buildListener('onNativePaySuccess', cb)
  }
  onNativeShare: any = (cb = data => data) => {
    this._buildListener('onNativeShare', cb)
  }
  _setupWebViewJavascriptBridge: any = () => {}
  _buildListener(fName, cb = data => data) {
    if (this.isAndroid) {
      const win: any = window
      return (win[fName] = cb)
    }
    this._setupWebViewJavascriptBridge(bridge => {
      bridge.registerHandler(fName, (data, responseCallback) => {
        cb(data)
      })
    })
  }
}
export const appGolbal = new AppGlobal()
